/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

document.addEventListener('DOMContentLoaded', function() {
  // Add custom code below this line
  var togetherSlider = new Swiper('.js-together-slider', {
    slidesPerView: 1,
    spaceBetween: 20,
    navigation: {
      nextEl: '.js-together-next',
      prevEl: '.js-together-prev'
    },
    pagination: {
      el: '.js-together-nav',
      type: 'bullets',
      clickable: true
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  if (!document.body.classList.contains('template-product')) return;

  const cartBar = document.getElementById('cart-bar');
  const footer = document.querySelector('footer');

  if (!footer || !cartBar) return;

  const OFFSET = 400;

  window.addEventListener('scroll', () => {
    const footerTop = footer.getBoundingClientRect().top;
    const viewportHeight = window.innerHeight;

    setTimeout(() => {
      if (footerTop < viewportHeight + OFFSET) {
        cartBar.classList.remove('is-visible');
      }
    }, 0);
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const prevCountry = JSON.parse(localStorage.getItem('country_iso_code'));

  if(prevCountry) return;

  const token = 'ce056ef4f6be0e';

  fetch(`https://ipinfo.io?token=${token}`)
  .then(res => res.json())
  .then(data => {
    const country = data.country;
    localStorage.setItem('country_iso_code', JSON.stringify(country));
  });
});

document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('submit', (event) => {
    const form = event.target;

    if (!(form instanceof HTMLFormElement)) return;

    const input = form.querySelector('input[name="q"]');

    if (!input) return;

    const value = input.value.trim();

    if (value && !value.endsWith('*')) {
      input.value = `${value}*`;
    }
  }, true);
});
